import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight, Heart, Video } from "lucide-react";

const SOCIETY_IMG = "https://static.prod-images.emergentagent.com/jobs/d1ab293c-7711-4c7c-9c82-fdf692c2b21b/images/b8ec4688e05cf26329e7ef400e8914a2e7bfdce87f1986abeefbf4ec76b8174c.jpeg";
const MODELS_IMG = "https://static.prod-images.emergentagent.com/jobs/d1ab293c-7711-4c7c-9c82-fdf692c2b21b/images/fd06078c0f7c9d39a85a62b1015a1285258b0f255823a0bcbe67293c26df1665.jpeg";

function Half({ to, img, kicker, title, subtitle, blurb, icon: Icon, testId, delay, align = "left", overlay = "bg-ink/70 group-hover:bg-ink/55", position = "object-center" }) {
  return (
    <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }} className="relative flex-1 min-h-[50vh] lg:min-h-0">
      <Link to={to} data-testid={testId} className="group relative block h-full w-full overflow-hidden focus:outline-none">
        <img src={img} alt="" className={`absolute inset-0 w-full h-full object-cover ${position} scale-105 group-hover:scale-110 transition-transform duration-[1400ms] ease-out`} draggable={false} />
        <div className={`absolute inset-0 ${overlay} transition-colors duration-700`} />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/25 to-ink/20" />
        <div className={`relative h-full flex flex-col justify-end p-8 sm:p-12 lg:p-16 ${align === "right" ? "lg:items-end lg:text-right" : ""}`}>
          <span className="w-12 h-12 rounded-full border border-gold/40 bg-ink/60 backdrop-blur flex items-center justify-center mb-8 group-hover:border-gold transition-colors"><Icon size={18} className="text-gold" strokeWidth={1.5} /></span>
          <p className="text-[11px] uppercase tracking-[0.35em] text-gold mb-4">{kicker}</p>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-light leading-[0.9] tracking-tight">
            <span className="brand-script block text-[1.3em] mb-3">Velluto</span><span className="text-text-main/90">{title}</span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-text-main/85 uppercase tracking-[0.25em]">{subtitle}</p>
          <p className="mt-3 text-sm text-text-muted max-w-sm">{blurb}</p>
          <span className="mt-8 inline-flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-gold">
            <span className="h-px w-8 bg-gold/60 group-hover:w-16 transition-all duration-500" /> Enter <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
          </span>
        </div>
      </Link>
    </motion.div>
  );
}

export default function Hub() {
  const { user } = useAuth();
  return (
    <div data-testid="hub-page" className="min-h-screen pt-16 flex flex-col lg:flex-row bg-ink">
      <Half to="/browse" img={SOCIETY_IMG} icon={Heart} testId="hub-society" delay={0.05}
        kicker={`Welcome${user?.display_name ? `, ${user.display_name}` : ""}`} title="SOCIETY" subtitle="Dating and Connections"
        blurb="Discover, match and meet consenting adults who share your tastes — discreetly."
        overlay="bg-ink/35 group-hover:bg-ink/20" position="object-[50%_40%] lg:object-[50%_45%]" />
      <div className="hidden lg:block w-px bg-gradient-to-b from-transparent via-gold/50 to-transparent" />
      <Half to="/models" img={MODELS_IMG} icon={Video} testId="hub-models" delay={0.2} align="right"
        kicker="Live now" title="MODELS" subtitle="CamChat" overlay="bg-ink/35 group-hover:bg-ink/20" position="object-[50%_35%] lg:object-[50%_40%]"
        blurb="Live streams, private cam-to-cam sessions and gifting with verified creators." />
    </div>
  );
}
